var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("Teste de carga de video")]),_vm._v(" "),_c('VideoJSRecord'),_vm._v(" "),_vm._l((_vm.videos),function(video){return _c('div',{key:video.id,staticClass:"block_movie"},[_c('VideoPlayer',{attrs:{"options":{
    autoplay: false,
    responsive: true,
    controls: true,
    sources: [
    {
    src: video.video_path,
    type: 'video/mp4'
    }
    ]
    }}})],1)}),_vm._v(" "),_c('VideoPlayer',{attrs:{"options":{
    autoplay: false,
    responsive: true,
    controls: true,
    sources: [
    {
    src: '/a.mp4',
    type: 'video/mp4'
    }
    ]
    }}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }